import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DYNAMIC_COMPONENT_DATA } from '@principle-theorem/ng-shared';
import {
  DTX_STUDIO_DRIVER_DIRECT_INTEGRATION,
  type DtxStudioDriverDirectIntegrationCommand,
  DtxStudioDriverDirectToDeviceCommand,
} from '@principle-theorem/principle-bridge-core';
import { BridgeCommandsService } from '../../../bridge-commands.service';
import { IIntegrationActionData } from '../../../integration-action-data';
import { BridgeDeviceSelectorService } from '../../bridge-device-selector-dialog/bridge-device-selector.service';

@Component({
  selector: 'pr-dtx-studio-driver-direct-trigger',
  imports: [MatButtonModule],
  templateUrl: './dtx-studio-driver-direct-trigger.component.html',
  styleUrl: './dtx-studio-driver-direct-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DtxStudioDriverDirectTriggerComponent {
  private readonly _data = inject<IIntegrationActionData>(
    DYNAMIC_COMPONENT_DATA
  );
  private readonly _bridgeCommands = inject(BridgeCommandsService);
  private readonly _bridgeDeviceSelector = inject(BridgeDeviceSelectorService);

  async acquireImages(): Promise<void> {
    const device = await this._bridgeDeviceSelector.selectDevice(
      DTX_STUDIO_DRIVER_DIRECT_INTEGRATION
    );
    if (!device) {
      return;
    }
    const command: DtxStudioDriverDirectIntegrationCommand = {
      type: DtxStudioDriverDirectToDeviceCommand.TriggerImageCapture,
      data: { patient: this._data.patient },
    };
    await this._bridgeCommands.sendCommand(command, device.ref);
  }
}
